import type { Hero, Level, LevelRecord, Phase } from "./types";
import { LEVELS } from "./levels";
import { heroesFor, payoffMatrix } from "./payoff";

/** Payoff matrices are fixed per level — compute once. */
const MATRICES = LEVELS.map(payoffMatrix);

/** Mutable, session-global game state, kept in one object so feature modules
 *  can share it without a tangle of cross-module setters. */
export const state = {
  /** The current level definition. */
  level(): Level { return LEVELS[this.idx]; },
  /** Payoff matrix of the current level (rows = heroes, cols = quests). */
  values(): number[][] { return MATRICES[this.idx]; },
  /** The bench for the current level. */
  heroes(): Hero[] { return heroesFor(LEVELS[this.idx]); },
  /** Number of heroes = number of contracts on the current level. */
  n(): number { return LEVELS[this.idx].heroCount; },
  phase: "intro" as Phase,
  /** Current level index. */
  idx: 0,
  /** Working roster: assign[heroIdx] = questIdx, -1 = on the bench. */
  assign: [] as number[],
  /** The currently selected hero (bench tap), -1 = none. */
  selected: -1,
  /** Whether each day has been completed at the proven-best total. */
  completed: LEVELS.map(() => false),
  /** Persisted working roster per level, so navigating back restores work. */
  saved: LEVELS.map((L) => new Array<number>(L.heroCount).fill(-1)),
  /** Best completed roster per level (highest gold), fed to the reveal. */
  records: LEVELS.map((): LevelRecord => ({ assign: [], total: 0 })),
};

/** Payoff matrix for an arbitrary level (used by the reveal's mini ledgers). */
export function valuesFor(levelIdx: number): number[][] {
  return MATRICES[levelIdx];
}
